import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";

import Api from "../../services/Api";
import useAuth from "../../routes/login/AuthContext";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import { Link } from "../Link";
import { Typography } from "../../UI/Typography";
import { Box } from "../../UI/Box";
import { useSnackbar } from "../../hooks/useSnackbar";

export const UserMembershipRemovalModal = (props) => {
  const { setIsOpen } = useModalContext();
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();

  const onHide = () => {
    setIsOpen(false);
  };

  const handleRemove = async () => {
    try {
      const success = await Api.deleteUserMembership(props.userId, await getAuthToken());

      if (success) {
        if (props.onSuccess) props.onSuccess();
        showSuccessSnackbar("Membership successfully removed");
        onHide();
      } else {
        showErrorSnackbar("An error occurred. Please try again");
      }
    } catch (error) {
      showErrorSnackbar("An error occurred. Please try again");
    }
  };

  return (
    <Modal
      title="Confirm Membership Deletion"
      actions={
        <>
          <Button appearance="subtle" onClick={onHide}>
            Cancel
          </Button>
          <Button appearance="danger" onClick={handleRemove} iconBefore={<EditorRemoveIcon label="Trash" />}>
            Delete Membership
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          You are about to delete the membership for the user listed below. This user will no longer have access to
          their membership in RoomSync.
        </Typography>
        <Typography variant="body2" gutterBottom>
          If you have questions about how this tool works, please call us at
          {PHONE_NUMBER} or e-mail <Link href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</Link>
        </Typography>
        <Typography variant="body2" gutterBottom>
          Delete Membership of: {props.name}
        </Typography>
      </Box>
    </Modal>
  );
};

UserMembershipRemovalModal.defultProps = {
  onSuccess: () => {},
};
